export const MEN_DATA_LOADING = "MEN_DATA_LOADING";

export const MEN_DATA_SUCCESS = "MEN_DATA_SUCCESS";
export const MEN_DATA_FAILURE = "MEN_DATA_FAILURE";

export const PRODUCTS_DATA_LOADING = "PRODUCTS_DATA_LOADING";

export const PRODUCTS_DATA_SUCCESS = "PRODUCTS_DATA_SUCCESS";
export const PRODUCTS_DATA_FAILURE = "PRODUCTS_DATA_FAILURE";
export const WOMEN_DATA_LOADING = "WOMEN_DATA_LOADING";

export const WOMEN_DATA_SUCCESS = "WOMEN_DATA_SUCCESS";
export const WOMEN_DATA_FAILURE = "WOMEN_DATA_FAILURE";
export const KIDS_DATA_SUCCESS = "KIDS_DATA_SUCCESS";

export const KIDS_DATA_LOADING = "KIDS_DATA_LOADING";
export const KIDS_DATA_FAILURE = "KIDS_DATA_FAILURE";


export const CART_DATA_SUCCESS = "CART_DATA_SUCCESS";

export const CART_DATA_LOADING = "CART_DATA_LOADING";
export const CART_DATA_FAILURE = "CART_DATA_FAILURE";

export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";

export const ADD_TO_CART_LOADING = "ADD_TO_CART_LOADING";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";


export const COUNT_CART_SUCCESS = "COUNT_CART_SUCCESS";

export const COUNT_CART_LOADING = "COUNT_CART_LOADING";
export const COUNT_CART_FAILURE = "COUNT_CART_FAILURE";


export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS";

export const DELETE_CART_LOADING = "DELETE_CART_LOADING";
export const DELETE_CART_FAILURE = "DELETE_CART_FAILURE";
